import React from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody, Button, Alert} from 'reactstrap';
import {FormattedDate, FormattedMessage, FormattedTime} from "react-intl";
import moment from 'moment';
import Formsy from 'formsy-react';
import InputFormGroup from "components/Form/InputFormGroup";
import Loading from "components/Loading";
import {getStatusFromError} from "helpers/errors";
import IconSvg from "../../../../components/IconSvg";

class Note extends React.Component {
    static propTypes = {
        note: PropTypes.shape({
            timeCreated: PropTypes.number.isRequired,
            note: PropTypes.string.isRequired,
            favourite: PropTypes.bool,
        }).isRequired,
        onFavouriteToggle: PropTypes.func.isRequired,
        onEdit: PropTypes.func.isRequired,
    };

    componentWillMount() {
        this.setState({
            opened: false,
            valid: false,
        });
    }

    edit(model) {
        this.setState({
            loading: true,
        });
        this.props.onEdit(model.note).then(() => {
            this.setState({
                loading: false,
                opened: false,
            });
        }).catch(e => {
            this.setState({
                loading: false,
                status: getStatusFromError(e),
            });
        });
    }

    render() {
        const {status, loading, valid} = this.state;
        const {note, onFavouriteToggle} = this.props;

        const created = moment.unix(note.timeCreated);

        return (
            <div className="note">
                <a onClick={onFavouriteToggle} className={"clickable note__fav" + (note.favourite ? " note__fav--active" : '')}>
                    <IconSvg id='fav'/>
                </a>
                <a onClick={() => this.setState({opened: true})} className={"clickable note__edit"}>
                    <IconSvg id='edit'/>
                </a>
                <Modal keyboard autoFocus isOpen={this.state.opened} modalClassName="modal-small" toggle={() => this.setState({opened: false})}>
                    <ModalHeader toggle={() => this.setState({opened: false})}>
                        <FormattedMessage id="conversation.edit_note" defaultMessage="Edit note"/>
                    </ModalHeader>
                    <ModalBody>
                        <Formsy className="form" onValidSubmit={::this.edit} onInvalid={() => this.setState({valid: false})} onValid={() => this.setState({valid: true})}>
                            <InputFormGroup type="textarea" id="form-note-edit" name="note" value={note.note} label={(
                                <FormattedMessage id="conversation.new_note.text_label" defaultMessage="Note text"/>)}
                                            required
                            />

                            {status &&
                                <Alert color={status.type}>
                                    {status.message}
                                </Alert>
                            }

                            <Button type="submit" color="secondary" block disabled={!valid || loading}>
                                {loading &&
                                <Loading inline small/>
                                }
                                <FormattedMessage id="conversation.new_note.save" defaultMessage="Save"/>
                            </Button>
                        </Formsy>
                    </ModalBody>
                </Modal>
                <div className="note__date">
                    <FormattedDate value={created} /> <FormattedTime value={created} />
                </div>
                <div className="note__text">
                    {note.note}
                </div>
            </div>
        )
    }
}

export default Note;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Notes/Note.jsx